import moment, { Moment } from "moment";
import { DateFormats, TimeConstant } from "./constant";

const FormatString=(str: string, ...val: string[])=>{
  for (let index = 0; index < val.length; index++) {
    str = str.replace(`{${index}}`, val[index]);
  }
  return str;
}

const getDatesOfWeek = (start: Moment) => {
  const datesOfWeek = [start.format(DateFormats.FullDate)];
  for (let i = 1; i < 5; i++) {
    datesOfWeek.push(start.clone().add(i, "day").format(DateFormats.FullDate));
  }
  return datesOfWeek;
};

const setKey = async (keyName : string, keyValue: any) => {  

  const data = {
    value: keyValue,    
    expiryTime: moment().valueOf() + TimeConstant.cacheExpiryInMilliseconds
  }

  localStorage.setItem(keyName, JSON.stringify(data));
};

const getKey = async (keyName: string) => {

  const data = localStorage.getItem(keyName);

  if (!data) {
    return null;
  }

  const item = JSON.parse(data);

  if (moment().valueOf() > item.expiryTime) {
    localStorage.removeItem(keyName);
    return null;
  }

  return item.value;
};

const Extensions={
    FormatString,
    getDatesOfWeek,
    setKey,
    getKey
};

export default Extensions;
